import { useObserver } from "mobx-react";
import { useStores } from "../../store";
import { FaCheckCircle } from "react-icons/fa";
import { GoCheckCircle } from "react-icons/go";
import { IoMdCloseCircle } from "react-icons/io";

export default function Checkbox2(props) {
  const { CommonStore } = useStores();
  return useObserver(() => (
    <div
      className="flex flex-col justify-center md:gap-x-10 lg:gap-x-10 gap-x-2 cursor-pointer z-10 "
      onClick={() => {
        CommonStore.setBotLabel(props.label);
        CommonStore.setProgress(props.ind);
      }}
    >
      {props.rejected ? (
        <IoMdCloseCircle className=" md:text-3xl lg:text-3xl text-2xl bg-white text-red-500 m-0 p-0" />
      ) : props.hired ? (
        <FaCheckCircle className=" md:text-3xl lg:text-3xl text-2xl bg-white text-green-500" />
      ) : props.completed && props.active ? (
        <FaCheckCircle className=" md:text-3xl lg:text-3xl text-2xl bg-white text-green-500 m-0 p-0" />
      ) : (
        <GoCheckCircle className=" md:text-3xl lg:text-3xl text-2xl bg-white text-[#D2D1D1] m-0 p-0" />
      )}
      <span
        className={` md:text-base lg:text-base md:mb-0 lg:mb-0 text-xs mb-3 ${
          props.rejected
            ? "text-red-500"
            : props.hired
            ? "text-green-500"
            : props.completed && props.active
            ? "text-green-500"
            : "text-[#ACACAC]"
        } w-fit  md:w-[6.8em] truncate lg:w-36`}
      >
        {props.rejected ? "Rejected" : <>{props.label}</>}
      </span>
    </div>
  ));
}
